import { render, staticRenderFns } from "./FormularioControlMujer.vue?vue&type=template&id=1224260e&scoped=true"
import script from "./FormularioControlMujer.vue?vue&type=script&lang=js"
export * from "./FormularioControlMujer.vue?vue&type=script&lang=js"
import style0 from "./FormularioControlMujer.vue?vue&type=style&index=0&id=1224260e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1224260e",
  null
  
)

export default component.exports